import axiosInstance from '../RestClient';

const BASE_URI = '/esignature';

class EsignatureService {
	async getStatus() {
		const uri = `${BASE_URI}/status`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async getSettings() {
		const uri = `${BASE_URI}/settings`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async updateSettings(payload) {
		const uri = `${BASE_URI}/settings`;
		const response = await axiosInstance.put(uri, payload);
		return response;
	}

	async uploadSignatureImage(formData) {
		const uri = `${BASE_URI}/settings/signature-image`;
		const response = await axiosInstance.post(uri, formData, { headers: { 'Content-Type': undefined } });
		return response;
	}

	async listTemplates(q) {
		const uri = q ? `${BASE_URI}/templates?q=${encodeURIComponent(q)}` : `${BASE_URI}/templates`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async getTemplate(templateId) {
		const uri = `${BASE_URI}/templates/${templateId}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async listSubmissions() {
		const uri = `${BASE_URI}/submissions`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async linkSubmission(documentId, payload) {
		const uri = `${BASE_URI}/documents/${documentId}/link`;
		const response = await axiosInstance.post(uri, payload);
		return response;
	}

	async prepare(documentId, roles) {
		const uri = `${BASE_URI}/documents/${documentId}/prepare`;
		const response = await axiosInstance.post(uri, { roles });
		return response;
	}

	async send(documentId, payload) {
		const uri = `${BASE_URI}/documents/${documentId}/send`;
		const response = await axiosInstance.post(uri, payload);
		return response;
	}

	async refresh(documentId) {
		const uri = `${BASE_URI}/documents/${documentId}/refresh`;
		const response = await axiosInstance.get(uri);
		return response;
	}
}

export default new EsignatureService();
